import { render } from "./CouponManage.vue?vue&type=template&id=28cbe83c&scoped=true"
import script from "./CouponManage.vue?vue&type=script&lang=js"
export * from "./CouponManage.vue?vue&type=script&lang=js"

import "./CouponManage.vue?vue&type=style&index=0&id=28cbe83c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28cbe83c"]])

export default __exports__